import React, { useState } from "react";
import FormLayout from "../form-layout";
import RejectionModal from "./rejection-modal";
import { Q10_MEDICATIONS } from "../../data/eligibility-rules";
import { checkImmediateRed } from "../../lib/eligibility";

// Q10 — "Are you currently taking any of the following medications?"
export default function StepMedication({ formData, setFormData, onBack, goToStep }) {
  const [selected, setSelected] = useState(formData.q10Medications || []);
  const [rejection, setRejection] = useState(null);

  const toggle = (key) => {
    if (key === "none") {
      setSelected(["none"]);
      return;
    }
    setSelected((prev) => {
      const withoutNone = prev.filter((k) => k !== "none");
      return withoutNone.includes(key) ? withoutNone.filter((k) => k !== key) : [...withoutNone, key];
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selected.length) return;

    const nextFormData = { ...formData, q10Medications: selected };
    setFormData(nextFormData);
    localStorage.setItem("q10Medications", JSON.stringify(selected));

    const redFlag = checkImmediateRed(nextFormData);
    if (redFlag) {
      setRejection(redFlag);
      return;
    }

    goToStep("9a");
  };

  return (
    <FormLayout title="" goToStep={goToStep} onBack={onBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-6">
        Are you currently taking any of the following medications? (Select all that apply)
      </h2>

      <form onSubmit={handleSubmit}>
        <ul className="flex flex-col gap-3 mb-6 list-none p-0">
          {Q10_MEDICATIONS.map((option) => {
            const isSelected = selected.includes(option.key);
            return (
              <li key={option.key}>
                <label className="flex items-center gap-2 p-3 rounded-lg cursor-pointer border transition-all text-sm sm:text-[14px] font-medium text-[#000000]">
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => toggle(option.key)}
                    className="h-4 w-4 accent-sky-400 cursor-pointer"
                  />
                  <span className="text-gray-800 text-sm sm:text-[14px]">{option.label}</span>
                </label>
              </li>
            );
          })}
        </ul>

        <div className="flex justify-start">
          <button
            type="submit"
            disabled={!selected.length}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${!selected.length ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"}`}
          >
            Next →
          </button>
        </div>
      </form>

      {rejection && <RejectionModal onClose={() => setRejection(null)} />}
    </FormLayout>
  );
}
